import { render } from "./ResetMail.vue?vue&type=template&id=78aef26c"
import script from "./ResetMail.vue?vue&type=script&lang=js"
export * from "./ResetMail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__